var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"logo",attrs:{"src":_vm.$beforeUrl(_vm.$store.state.app.info.waplogo)}})}
var staticRenderFns = []

export { render, staticRenderFns }